import React,{useEffect} from "react";
import { Course } from "../../@types/course.interface";
import "./quiz-form.styles.scss";
import { Quiz, QuizBasic } from "../../@types/quiz.interfaces";
import Button from "../button/button.component";
import { useHistory } from "react-router-dom";

interface IProps {
    quiz: Quiz | QuizBasic;
    courses: Course[];
    handleClick: (evt: any) => void;
    handleChange: (evt: any, name: string) => void;
    error: string | null;
    update?: boolean;
    id?: number | undefined;
}

export default function QuizForm({
    quiz,
    courses,
    handleClick,
    handleChange,
    error,
    update,
    id,
}: IProps) {
    const history = useHistory();
    
    const handlePush = (id?:number) => {
        history.push(`/quiz/${id}/question`); 
        window.location.reload();
    };

    return (
        <div className="quiz">
            <div className="title">
                <h2 className="heading">
                    {update ? "Update Quiz" : "Create Quiz"}
                </h2>
            </div>
            <form className="quiz__form" action="#" method="post">
                <div className="quiz__form__input">
                    <div className="quiz__form__input__label">
                        <span>Courses</span>
                    </div>
                    <select
                        className="quiz__form__input__select cursor"
                        onChange={(evt) => handleChange(evt, "course_id")}
                        defaultValue={update ? undefined : "-"}
                        value={update ? `${quiz.course_id}` : undefined}
                    >
                        <option value="-" disabled>
                            Select Quiz Course
                        </option>
                        {courses.map((course, index) => {
                            return (
                                <option value={course.course_id} key={index}>
                                    {course.course_name}
                                </option>
                            );
                        })}
                    </select>
                </div>
                <div className="quiz__form__input">
                    <div className="quiz__form__input__label">
                        <span>Quiz Duration</span>
                    </div>
                    <label
                        className={"quiz__form__input__indicator"}
                        style={{
                            marginLeft: `${
                                (quiz.quiz_duration + "").length * 10 + 190
                            }px`,
                        }}
                    >
                        minutes
                    </label>
                    <input
                        className="quiz__form__input__number"
                        type="number"
                        placeholder="0"
                        defaultValue={update ? undefined : 0}
                        value={update ? `${quiz.quiz_duration}` : undefined}
                        min={0}
                        onChange={(evt) => handleChange(evt, "quiz_duration")}
                    />
                </div>
                {error ? (
                    <div className="quiz__form__error error">{error}</div>
                ) : (
                    ""
                )}
                <div className="quiz__form__button">
                    <Button
                        className="dark"
                        type="submit"
                        onClick={handleClick}
                    >
                        {update ? "Save" : "Create"}
                    </Button>
                </div>
                {update ? (
                    <div className="quiz__manage-question">
                        <div className="quiz__manage-question__label">
                            Manage Question ?
                        </div>
                        <div className="quiz__manage-question__button">
                            <Button
                                type="button"
                                onClick={() =>
                                   handlePush(id)
                                }
                            >
                                Question
                            </Button>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </form>
        </div>
    );
}
